import type { EnumUnion } from '@dresscode-frontend/utility-types';

import type {
  ReleaseTestDocumentListItem,
  ReleaseTestDocumentStatus,
  ReleaseTestDocumentType,
} from '@/features/stacktrace/qa-force/release-test-documents/-query/type';

/**
 * テストスイート詳細 > ドキュメントタブのテーブル列ID。
 *
 * 表示順:
 *   ドキュメント名 / ステータス / 種別 / 作成日 / 更新日 / 作成者 / 更新者
 */
export const ReleaseTestDocumentTableColumns = {
  NAME: 'NAME',
  STATUS: 'STATUS',
  STATUS_LABEL: 'STATUS_LABEL',
  TYPE: 'TYPE',
  CREATED_AT: 'CREATED_AT',
  UPDATED_AT: 'UPDATED_AT',
  CREATED_BY: 'CREATED_BY',
  UPDATED_BY: 'UPDATED_BY',
} as const;
export type ReleaseTestDocumentTableColumns = EnumUnion<
  typeof ReleaseTestDocumentTableColumns
>;

type ReleaseTestDocumentNameColumn = {
  id: string;
  name: string;
  /** 行先頭アイコンの判定用。外部 URL らしいなら ↗ にする */
  linkUrl: string;
};

type ReleaseTestDocumentPersonColumn = {
  personId: string;
  name: string | null;
};

export type ReleaseTestDocumentTableRowData = {
  [ReleaseTestDocumentTableColumns.NAME]: ReleaseTestDocumentNameColumn;
  [ReleaseTestDocumentTableColumns.STATUS]:
    | ReleaseTestDocumentStatus
    | undefined;
  [ReleaseTestDocumentTableColumns.STATUS_LABEL]: string | undefined;
  [ReleaseTestDocumentTableColumns.TYPE]: ReleaseTestDocumentType | undefined;
  [ReleaseTestDocumentTableColumns.CREATED_AT]: string;
  [ReleaseTestDocumentTableColumns.UPDATED_AT]: string;
  [ReleaseTestDocumentTableColumns.CREATED_BY]: ReleaseTestDocumentPersonColumn;
  [ReleaseTestDocumentTableColumns.UPDATED_BY]: ReleaseTestDocumentPersonColumn;
};

export const convertReleaseTestDocumentItemToTableRow = (
  item: ReleaseTestDocumentListItem,
): ReleaseTestDocumentTableRowData => {
  return {
    [ReleaseTestDocumentTableColumns.NAME]: {
      id: item.id,
      name: item.name,
      linkUrl: item.linkUrl,
    },
    [ReleaseTestDocumentTableColumns.STATUS]: item.status as
      | ReleaseTestDocumentStatus
      | undefined,
    [ReleaseTestDocumentTableColumns.STATUS_LABEL]: undefined,
    [ReleaseTestDocumentTableColumns.TYPE]: item.type as
      | ReleaseTestDocumentType
      | undefined,
    [ReleaseTestDocumentTableColumns.CREATED_AT]: item.createdAt,
    [ReleaseTestDocumentTableColumns.UPDATED_AT]: item.updatedAt,
    [ReleaseTestDocumentTableColumns.CREATED_BY]: {
      personId: item.createdPersonId,
      name: item.createdPersonName,
    },
    [ReleaseTestDocumentTableColumns.UPDATED_BY]: {
      personId: item.updatedPersonId,
      name: item.updatedPersonName,
    },
  };
};

/** 外部 URL かを簡易判定 */
export function isExternalLink(linkUrl: string | undefined): boolean {
  if (!linkUrl) return false;
  return /^https?:\/\//i.test(linkUrl);
}
